import { render } from "./SignupDialog.vue?vue&type=template&id=6f74e5a4&scoped=true"
import script from "./SignupDialog.vue?vue&type=script&lang=js"
export * from "./SignupDialog.vue?vue&type=script&lang=js"

import "./SignupDialog.vue?vue&type=style&index=0&id=6f74e5a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f74e5a4"]])

export default __exports__